<template>
  <div class="subscription">
    <payment-loading-view />
    <menu-view />
    <router-view />
  </div>
</template>

<script>
// @ is an alias to /src
import MenuView from "@/components/Subscription/Menu.vue";
import PaymentLoadingView from "@/components/Checkout/PaymentLoading.vue";

export default {
  name: "subscription",
  data() {
    return {};
  },
  components: {
    "menu-view": MenuView,
    "payment-loading-view": PaymentLoadingView,
  },
  mounted() {
    this.load();
  },
  methods: {
    load: function() {},
  },
};
</script>

<style scoped>
.subscription {
  float: left;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
}
.payment-loading {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
</style>
